import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "../Pages/Gallery.css";
import { Helmet } from "react-helmet";

// IMAGES
import VAN1 from "../images/VAN6.jpg";
import VAN2 from "../images/VAN7.jpg";
import VAN3 from "../images/VAN8.jpg";
import VAN4 from "../images/VAN9.jpg";
import VAN5 from "../images/VAN10.jpg";

// VIDEOS
import VIDEO1 from "../images/VIDEO1.mp4";
import VIDEO2 from "../images/VIDEO2.mp4";
import VIDEO3 from "../images/VIDEO3.mp4";
import VIDEO4 from "../images/VIDEO4.mp4";

export default function Gallery() {
  const imageList = [VAN1, VAN2, VAN3, VAN4, VAN5];
  const videoList = [VIDEO1, VIDEO2, VIDEO3, VIDEO4];

  return (
    <>
 <Helmet>
  <title>Gallery | Van Photos & Travel Videos | Sri Rajalakshmi Travels</title>

  <meta
    name="description"
    content="Explore premium van photos, traveller van interiors, rental car images and travel videos of Sri Rajalakshmi Travels – Aruppukottai."
  />

  <meta
    name="keywords"
    content="Aruppukottai travels gallery, van images Aruppukottai, traveller van photos, rental car gallery, tourist van interior"
  />

  <link rel="canonical" href="https://srirajalakshmitravels.in/Gallery" />

  {/* Main Business Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "TravelAgency",
      name: "Sri Rajalakshmi Travels",
      image: "https://srirajalakshmitravels.com/static/media/SRILOGO.538e1e7c6643833d5ce3.png",
      url: "https://srirajalakshmitravels.in",
      telephone: "+91 90952 23243",
      address: {
        "@type": "PostalAddress",
        streetAddress: "12/4 Main Road",
        addressLocality: "Aruppukottai",
        addressRegion: "Tamil Nadu",
        postalCode: "626101",
        addressCountry: "IN",
      },
      openingHours: "Mo-Su 00:00-23:59",
      priceRange: "₹₹",
      sameAs: [
        "https://www.facebook.com/",
        "https://www.instagram.com/",
      ],
    })}
  </script>

  {/* Service Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Van Rental, Car Rental, Tourist Vehicle Booking",
      provider: {
        "@type": "TravelAgency",
        name: "Sri Rajalakshmi Travels",
      },
      areaServed: "Aruppukottai, Virudhunagar",
    })}
  </script>

  {/* Review Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Review",
      itemReviewed: {
        "@type": "LocalBusiness",
        name: "Sri Rajalakshmi Travels",
        address: {
          "@type": "PostalAddress",
          streetAddress: "12/4 Main Road",
          addressLocality: "Aruppukottai",
          addressRegion: "Tamil Nadu",
          postalCode: "626101",
          addressCountry: "IN",
        },
      },
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
      author: {
        "@type": "Person",
        name: "Verified Customer",
      },
      reviewBody:
        "Excellent van rental service in Aruppukottai. Clean vehicles, friendly driver and on-time pickup!",
    })}
  </script>
</Helmet>


      <Navbar />

      <div className="gallery-wrapper">

        {/* IMAGE SECTION */}
        <h2 className="gallery-heading">Image Gallery</h2>
        <div className="image-grid">
          {imageList.map((img, idx) => (
            <div className="image-card" key={idx}>
              <img src={img} alt="van-img" />
            </div>
          ))}
        </div>

        {/* VIDEO SECTION */}
        <h2 className="gallery-heading">Travel Videos (Shorts Style)</h2>

        <div className="video-scroll">
          {videoList.map((vid, idx) => (
            <div className="video-card" key={idx}>
              <video
                src={vid}
                className="shorts-video"
                controls
                playsInline
              />
            </div>
          ))}
        </div>

      </div>

      <Footer />
    </>
  );
}
